<style scoped>
  .app {
    display: -webkit-box;      /* OLD - iOS 6-, Safari 3.1-6 */
    display: -moz-box;         /* OLD - Firefox 19- (buggy but mostly works) */
    display: -webkit-flex;     /* NEW - Chrome */
    display: flex;             /* NEW, Spec - Opera 12.1, Firefox 20+ */
    -webkit-box-flex-direction: row;
    -moz-box-flex-direction: row;
    -webkit-flex-direction: row;
    flex-direction: row;
    height:100vh;
    flex: 1;
    background: white;
    justify-content: center;
    align-items: center;
  }

  .loginWrapper {
    min-height: 400px;
    padding: 30px;
    display: flex;
    flex-direction: column;
  }

  .ivu-carousel-item > div {
    background-size: cover;
    height:100vh;
    width:100%;
  }

  .logo {
    width: 100px;
  }
</style>

<template>
  <Row class="app">
    <i-col :xs="24" :md="8">
      <p style="text-align: center;">
        <img src="/static/img/logo-pantallas.png" class="logo" alt="Pantallas" />
      </p>
      <div class="loginWrapper">
        <i-form ref="formValidate" :model="form" :rules="rules" label-position="top">
          <Form-item label="Nombre de usuario" prop="username">
            <i-input v-model="form.username" size="large" autocomlpete="off" @on-enter="onSubmit('formValidate')">
              <Icon type="person" slot="prepend" size="18" color="#d1d1d2"></Icon>
            </i-input>
          </Form-item>
          <Form-item label="Contraseña" prop="password">
            <i-input v-model="form.password" type="password" size="large" autocomlpete="off" @on-enter="onSubmit('formValidate')">
              <Icon type="locked" slot="prepend" size="18" color="#d1d1d2"></Icon>
            </i-input>
          </Form-item>
          <i-button type="primary" size="large" long :loading="isLoading" @click="onSubmit('formValidate')">Iniciar sesión</i-button>
        </i-form>
      </div>
    </i-col>
    <i-col :xs="0" :md="16" style="height:100%;position: relative;">
      <Carousel style="max-height: 100%;" dots="none" :autoplay="true">
        <Carousel-item>
          <div style="background-image: url('/static/img/malecon.jpg');">&nbsp;</div>
        </Carousel-item>
        <Carousel-item>
          <div style="background-image: url('/static/img/palacio-gobierno.jpg');">&nbsp;</div>
        </Carousel-item>
        <Carousel-item>
          <div style="background-image: url('/static/img/pantallas-carousel.jpg');">&nbsp;</div>
        </Carousel-item>
        <Carousel-item>
          <div style="background-image: url('/static/img/pantallas.jpg');">&nbsp;</div>
        </Carousel-item>
        <Carousel-item>
          <div style="background-image: url('/static/img/ventana-oficinas.jpg');">&nbsp;</div>
        </Carousel-item>
      </Carousel>
      <div style="position: absolute;bottom:0;left:0;right:0;height:150px;background-color: rgba(0,0,0,0.6);padding: 20px;">
        <h1 style="color: white;">Bienvenido a pantallas,</h1>
        <h2 style="color: white;">La mejor forma de administrar y distribuir tus contenidos</h2>
      </div>
    </i-col>
  </Row>
  <!--<div style="min-height:100%;border: 1px solid black;width:100%;">
    <Row type="flex">

    </Row>
  </div>-->
</template>

<script>

  export default {
    data() {
      return {
        form: {
          username: '',
          password: '',
        },
        isLoading: false,
        rules: {
          username: [
            { required: true, type: 'string', message: 'Este campo es requerido' },
          ],
          password: [
            { required: true, type: 'string', message: 'Este campo es requerido' },
            { min: 8, message: 'La contraseña debe tener al menos 8 caracteres' },
          ],
        },
      };
    },
    methods: {
      onSubmit(name) {
        this.$refs[name].validate((valid) => {
          if (valid) {
            const msg = this.$Message.loading('Iniciando sesión...', 0);
            this.isLoading = true;
            this.$store.dispatch({
              type: 'login',
              form: this.form,
            }).then((resp) => {
              this.isLoading = false;
              msg();
              this.$router.replace({
                path: '/admin/campaigns',
              });
            }).catch((err) => {
              this.isLoading = false;
              msg();
              this.$Message.error('Ocurrió un error al iniciar sesión. Verifique sus datos de acceso');
            });
          } else {
            this.$Message.error('Verifique sus datos de acceso');
          }
        });
      },
    },
    head: {
      title: {
        inner: 'Acceso al Sistema',
      },
    },
  };
</script>



// WEBPACK FOOTER //
// Login.vue?3bfe314c